var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKgs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_2871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_2871)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#C51918"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_2871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_2871)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.487 17.1225C11.5641 17.1225 11.6406 17.1198 11.7167 17.1145L12.1602 19.0003L12.2629 17.0302C12.4113 16.9944 12.557 16.9486 12.6997 16.8932L13.4601 18.5929L13.2164 16.6439C13.3538 16.5639 13.4874 16.4748 13.6168 16.377L14.6539 17.8L14.0764 15.9761C14.1956 15.857 14.31 15.7298 14.4191 15.5952L15.6773 16.6643L14.7971 15.0655C14.8924 14.9138 14.9818 14.7553 15.0649 14.5909L16.475 15.2472L15.3407 13.9609C15.4069 13.7845 15.4664 13.6028 15.5187 13.4166L17.0041 13.625L15.6767 12.7197C15.71 12.5284 15.7361 12.3334 15.7545 12.1353L17.2361 11.8851L15.7866 11.4091C15.7859 11.2088 15.7773 11.011 15.7613 10.8162L17.1584 10.1213L15.6673 10.1003C15.6319 9.90591 15.5889 9.71544 15.5389 9.52943L16.7753 8.42881L15.322 8.86271C15.2537 8.68486 15.1784 8.5124 15.0968 8.34595L16.1073 6.89877L14.7696 7.76374C14.6723 7.61168 14.569 7.46647 14.4602 7.32875L15.1906 5.6137L14.0412 6.86177C13.92 6.74322 13.7939 6.6329 13.6635 6.53142L14.0744 4.64286L13.1752 6.2052C13.0366 6.12687 12.8943 6.05789 12.7486 5.99887L12.8191 4.0386L12.217 5.83177C12.0689 5.79828 11.9182 5.7748 11.7654 5.76189L11.4922 3.8335L11.2192 5.76102C11.0661 5.77347 10.9151 5.79651 10.7667 5.82961L10.1654 4.0386L10.2357 5.99475C10.0892 6.05357 9.94608 6.12246 9.80671 6.20079L8.91001 4.64286L9.31949 6.52454C9.18782 6.62639 9.0606 6.73723 8.93834 6.85644L7.79388 5.6137L8.52064 7.32023C8.41054 7.45906 8.306 7.60553 8.20751 7.75901L6.87712 6.89877L7.88159 8.33724C7.79872 8.50552 7.7224 8.67996 7.65312 8.85993L6.20917 8.42881L7.43722 9.52199C7.38629 9.71041 7.34267 9.90342 7.3068 10.1004L5.82603 10.1213L7.21315 10.8113C7.19682 11.0088 7.18814 11.2094 7.18751 11.4125L5.74835 11.8851L7.21947 12.1335C7.23804 12.3344 7.26454 12.5321 7.29854 12.726L5.98033 13.625L7.45577 13.418C7.50881 13.6066 7.56922 13.7906 7.63651 13.9692L6.50946 15.2472L7.91121 14.5948C7.99534 14.761 8.08592 14.9211 8.18249 15.0743L7.3072 16.6643L8.55919 15.6005C8.66942 15.7361 8.78504 15.8641 8.90559 15.984L8.33057 17.8L9.36393 16.382C9.4943 16.4801 9.62893 16.5695 9.76736 16.6495L9.52438 18.5929L10.2832 16.8966C10.4264 16.9518 10.5727 16.9973 10.7217 17.0327L10.8243 19.0003L11.2676 17.1152C11.3403 17.1201 11.4135 17.1225 11.487 17.1225ZM14.7214 11.4194C14.7214 13.8006 13.2618 15.731 11.4612 15.731C9.66058 15.731 8.20091 13.8006 8.20091 11.4194C8.20091 9.03808 9.66058 7.10768 11.4612 7.10768C13.2618 7.10768 14.7214 9.03808 14.7214 11.4194ZM11.4823 14.7758C12.8435 14.7758 13.9471 13.3045 13.9471 11.4895C13.9471 11.0253 13.8749 10.5837 13.7447 10.1833C12.8682 10.2664 12.1996 10.6994 11.7554 11.1459L11.4026 11.5006L11.0732 11.1204C10.7576 10.7562 10.1483 10.346 9.21273 10.2055C9.08705 10.6 9.01753 11.0339 9.01753 11.4895C9.01753 13.3045 10.121 14.7758 11.4823 14.7758ZM9.70443 9.21331C10.1529 8.59067 10.7837 8.20313 11.4823 8.20313C12.17 8.20313 12.792 8.57868 13.239 9.18436C12.5355 9.29315 11.9389 9.52834 11.4545 9.89421C11.0226 9.56382 10.4388 9.34048 9.70443 9.21331Z",
    fill: "#FFDC17"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_2871)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_2871",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKgs);
export default __webpack_public_path__ + "static/media/KGS.aeb529c419ef7db78818b26d30966495.svg";
export { ForwardRef as ReactComponent };